/**
 * «C'è una sessione»: lo scrive `AuthProvider`, lo legge chi non può dipendere dal suo contesto
 * (`useModuleOn`, usato anche in componenti montati senza provider nelle prove).
 */
let present = false;

export function setSessionPresent(value: boolean): void {
  present = value;
}

export function isSessionPresent(): boolean {
  return present;
}
